import React from "react";
import ClubMap from "components/clubmap";
import "./program-map.scss";

const ProgramMap = () => {
  return <ClubMap />;
};

export default ProgramMap;
